import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { Table } from 'antd';

export default function BookingTable({
  list,
  loading,
  filters,
  columns,
  handleTableChange,
  onRowClick,
  ...restProps
}) {
  const [pageNumber, setPageNumber] = useState(filters?.pageNumber ?? 1);

  const handlePaginationChange = number => {
    setPageNumber(number);
  };

  useEffect(() => {
    if (isEmpty(filters)) {
      setPageNumber(1);
    }
    if (filters?.pageNumber && filters.pageNumber !== pageNumber) {
      setPageNumber(filters.pageNumber);
    }
  }, [filters]);

  return (
    <div className="booking-table-wrapper">
      <Table
        {...restProps}
        rowKey="referenceId"
        className={classNames('booking__table', {
          'booking__auto-table': loading || list?.edges?.length > 0,
        })}
        columns={columns}
        loading={loading}
        dataSource={list?.edges ?? []}
        onChange={handleTableChange}
        onRow={record => ({
          onClick: () => onRowClick(record),
        })}
        pagination={{
          current: pageNumber,
          pageSize: filters?.pageSize ?? 10,
          showSizeChanger: true,
          hideOnSinglePage: false,
          total: list?.totalCount,
          onChange: handlePaginationChange,
        }}
      />
    </div>
  );
}

BookingTable.propTypes = {
  list: PropTypes.shape({
    edges: PropTypes.array,
    totalCount: PropTypes.number,
  }),
  loading: PropTypes.bool,
  handleTableChange: PropTypes.func,
  onRowClick: PropTypes.func,
};

BookingTable.defaultProps = {
  list: {
    edges: [],
    totalCount: 0,
  },
  handleTableChange: () => {},
  onRowClick: () => {},
  loading: false,
};
